import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
      <h2>Introduction</h2>

        <p>I provide a warm, compassionate, and nonjudgmental space to facilitate growth and healing. I believe empathy, compassion, and reasonable humor are central to creating an effective therapeutic relationship that helps clients make meaningful changes over time.</p>
  
        <p>I received my Bachelor of Arts in Psychology from Eastern Illinois University and my Master of Arts in Applied Psychological Sciences from Pacific University. I have experience working with teens and adults from diverse backgrounds, including the LGBTQIA+, BIPOC, and neurodivergent communities.</p>
    
        <p>I typically see clients struggling with anxiety-related disorders, attention-deficit hyperactivity disorder (ADHD), depression, post-traumatic stress disorder (PTSD), and obsessive-compulsive disorder (OCD).</p>
    
        <p>Some evidence-based therapeutic approaches I utilize in treatment include Cognitive Behavioral Therapy, Exposure Response Prevention, Acceptance and Commitment Therapy, Dialectical Behavioral Therapy, and Mindfulness-Based Interventions.</p>

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
